














































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
class SpecialCard2 extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  readonly number: string
}

export default SpecialCard2
